/**
 * Request body and response is send as JSON string
 */
export type JSONStringValue = string;

export enum NetworkLogStatus {
  INIT = 'INIT',
  DONE = 'DONE',
  PENDING = 'PENDING',
}

export type NetworkRequestData = {
  url: string;
  method: string;
  body?: JSONStringValue;
};

export type NetworkResponseData = {
  status: number;
  body: JSONStringValue;
};
